import { SelectOption } from '@/shared/types';

import { FormAddress, AddressFieldName } from '@/api/types';

import { NullValueGuard } from '../../../middlewares/NullValueGuard';

interface PreviewProps {
  stringifiedAddress?: string;
  includeZipCode?: boolean;
}

function parseAddress(stringifiedAddress = ''): Nullable<FormAddress> {
  return stringifiedAddress ? JSON.parse(stringifiedAddress) : null;
}

export const AddressBlockPreview: React.FC<PreviewProps> = ({ stringifiedAddress, includeZipCode = false }) => {
  const address: Nullable<Partial<FormAddress>> = parseAddress(stringifiedAddress);

  return (
    <>
      <div className="custom-columns__row custom-columns__row_padding-tiny">
        <div className="custom-columns__col">
          <div className="custom-columns__title">Країна</div>
          <div className="custom-columns__info">
            <NullValueGuard>{address?.[AddressFieldName.country]?.label}</NullValueGuard>
          </div>
        </div>
        <div className="custom-columns__col">
          <div className="custom-columns__title">Область</div>
          <div className="custom-columns__info">
            <NullValueGuard>{address?.[AddressFieldName.region]?.label}</NullValueGuard>
          </div>
        </div>
        <div className="custom-columns__col">
          <div className="custom-columns__title">Район</div>
          <div className="custom-columns__info">
            <NullValueGuard>{address?.[AddressFieldName.district]?.label}</NullValueGuard>
          </div>
        </div>
      </div>

      <div className="custom-columns__row custom-columns__row_padding-tiny">
        <div className="custom-columns__col">
          <div className="custom-columns__title">Назва населеного пункту</div>
          <div className="custom-columns__info">
            <NullValueGuard>
              {(address?.[AddressFieldName.settlement] as SelectOption)?.label ||
                (address?.[AddressFieldName.settlement] as unknown as string)}
            </NullValueGuard>
          </div>
        </div>
        <div className="custom-columns__col">
          <div className="custom-columns__title">Назва вулиці</div>
          <div className="custom-columns__info">
            <NullValueGuard>
              {(address?.[AddressFieldName.street] as SelectOption)?.label ||
                (address?.[AddressFieldName.street] as unknown as string)}
            </NullValueGuard>
          </div>
        </div>
        {includeZipCode && (
          <div className="custom-columns__col">
            <div className="custom-columns__title">Індекс</div>
            <div className="custom-columns__info">
              <NullValueGuard>{address?.[AddressFieldName.zip_code]}</NullValueGuard>
            </div>
          </div>
        )}
      </div>

      <div className="custom-columns__row custom-columns__row_padding-tiny">
        <div className="custom-columns__col">
          <div className="custom-columns__title">Номер будинку</div>
          <div className="custom-columns__info">
            <NullValueGuard>{address?.[AddressFieldName.house]}</NullValueGuard>
          </div>
        </div>
        <div className="custom-columns__col">
          <div className="custom-columns__title">Номер корпусу</div>
          <div className="custom-columns__info">
            <NullValueGuard>{address?.[AddressFieldName.building]}</NullValueGuard>
          </div>
        </div>
        <div className="custom-columns__col">
          <div className="custom-columns__title">Номер квартири</div>
          <div className="custom-columns__info">
            <NullValueGuard>{address?.[AddressFieldName.apartment]}</NullValueGuard>
          </div>
        </div>
      </div>
    </>
  );
};
